import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = { class: "gy-3 row" }
const _hoisted_6 = { class: "ticket-configuration__item col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_OptionBox = _resolveComponent("OptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingSpinner, { loading: false }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.legal-disclaimer')), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_OptionBox, {
          title: _ctx.translate('shop.configuration.legal-disclaimer-checkbox-title'),
          type: "checkbox",
          name: "legal-disclaimer",
          isOptional: false,
          selectedOption: _ctx.checkedLegalDisclaimers,
          options: _ctx.disclaimerOptions,
          onChangeOption: _ctx.onChangeOption,
          labelAsHtml: true
        }, null, 8, ["title", "selectedOption", "options", "onChangeOption"])
      ])
    ])
  ], 64))
}